import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
} from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { ActiveGameServerService } from '../services/active-game-server.service';

export const gameServerInterceptor: HttpInterceptorFn = (
  request,
  next,
) => {
  const activeGameServerService =
    inject(ActiveGameServerService);

  const gameServerId =
    activeGameServerService.activeGameServerId();

  const isApiRequest =
    request.url.startsWith(
      environment.apiUrl,
    );

  const isGameServerRequest =
    request.url.startsWith(
      `${environment.apiUrl}/game-servers`,
    );

  if (
    !isApiRequest ||
    isGameServerRequest ||
    gameServerId === null
  ) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        'X-Game-Server-Id':
          String(gameServerId),
      },
    }),
  );
};
